import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({ baseURL: API_BASE_URL });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export interface HoroscopeEntry {
  sign: string;
  content: string;
  date: string;
}

export interface PromoStatus {
  enabled: boolean;
  until: string | null;
  banner: string;
  active: boolean;
}

export const horoscopeService = {
  async getToday(sign?: string): Promise<HoroscopeEntry> {
    const params = sign ? `?sign=${encodeURIComponent(sign)}` : '';
    const r = await api.get(`/horoscope/today${params}`);
    return r.data;
  },

  async getAll(): Promise<HoroscopeEntry[]> {
    const r = await api.get('/horoscope/all');
    return r.data;
  },

  async getPromo(): Promise<PromoStatus> {
    const r = await api.get('/settings/promotion');
    return r.data;
  },

  async updatePromo(data: Omit<PromoStatus, 'active'>): Promise<void> {
    await api.put('/settings/promotion', data);
  },
};

export default horoscopeService;
